export default {
  async link_init(_vm) {

  },
  link_getProjectsSortingFunction(field, direction) {
    return (a, b) => {
      let aProp = a[field];
      let bProp = b[field];
      // Considero solo la parte numerica del codice
      if (field === "projectId") {
        aProp = Number(aProp.replace(/LNK[0-9]{4}\//, ""));
        if (aProp.length >= 7) {
          aProp += Number(aProp.substring(3, 4)) * 10000;
        }
        bProp = bProp.replace(/LNK[0-9]{4}\//, "");
        if (bProp.length >= 7) {
          bProp += Number(bProp.substring(3, 4)) * 10000;
        }
      }
      if (direction === "ASC") {
        if (aProp > bProp) {
          return 1;
        }
        if (aProp < bProp) {
          return -1;
        }
        return 0;
      } else {
        if (aProp > bProp) {
          return -1;
        }
        if (aProp < bProp) {
          return 1;
        }
        return 0;
      }
    }
  },
  link_getAllowedStatuses(_vm) {
    let statuses = [6,1,2,3,4,5];
    if(_vm.userPermission > 3) {
      statuses = [1,2,3];
    }
    return statuses.map(s => _vm.$anm22.tableClasses.projectStatus().getById(s));
  },
  link_getOutgoCategories(_vm, payload) {
    return _vm.$store.getters['outgoCategoryProjectAssocs/getByProject'](payload.projectId)
    .map(ocp => _vm.$store.getters['outgoCategories/get'](ocp.category));
  },
  link_canEditProject(_vm, project) {
    return _vm.userPermission < 4 || (_vm.customerManager && _vm.project.status !== 3 && _vm.project.status !== 4 && _vm.project.status !== 5);
  },
  link_canDeleteProject(_vm, project) {
    return project.status === 6;
  },
  link_canAddEvent(_vm) {
    // Progetto completato
    const projectCompleted =  
      _vm.project.status === 3 && _vm.userPermission > 3;
    // Progetto fatturato o cancellato
    const projectInvoicedOrCanceled = _vm.project.status === 4 || _vm.project.status === 5 || _vm.project.status === 6;
    // Note spese del mese approvata
    const reportsApproved = _vm.reports
      .filter(r => 
        _vm.user.idWorldUser === r.user
        && _vm.$moment.unix(r.reportDate).isSame(_vm.$moment(), 'month') 
        && r.status === 1
      )
      .length === 0;
    return !projectCompleted && !projectInvoicedOrCanceled && reportsApproved;
  },
  link_canEditEvent(_vm, event) {
    // Carico gli employments così da avere il responsabile dipendente per ogni employment
    const creatorEmployments = _vm.$store.getters['employments/getByUser'](event.creator)
        .filter(e => _vm.project.developers.includes(e.work) && e.accountable === _vm.user.idWorldUser);
    const projectWaitingOrRunning = 
        (_vm.project.status < 3 || _vm.project.status === 6)
        && _vm.userPermission > 3 //manager
        && event.creator !== _vm.user.idWorldUser //creatore (anche tecnico)
        && !_vm.customerManager // responsabile cliente
        && creatorEmployments.length === 0 // responsabile dipendente del creatore
    ;
    const projectCompleted =  
        _vm.project.status === 3
        && _vm.userPermission > 3; //manager
    // Progetto fatturato o cancellato
    const projectInvoicedOrCanceled = _vm.project.status === 4 || _vm.project.status === 5;
    // Note spese del mese approvata
    const reportsApproved = _vm.reports
        .filter(r => 
          event.creator === r.user
          && _vm.$moment.unix(r.reportDate).isSame(_vm.$moment.unix(event.startTimestamp), 'month')
          && r.status === 1)
        .length === 0;
    return !projectWaitingOrRunning && !projectCompleted && !projectInvoicedOrCanceled && reportsApproved;
  },
  link_canAddOutgo(_vm) {
    // Progetto completato
    const projectCompleted =  
        _vm.project.status === 3
        && _vm.userPermission > 3; //manager
    // Progetto fatturato o cancellato
    const projectInvoicedOrCanceled = _vm.project.status === 4 || _vm.project.status === 5 || _vm.project.status === 6;
    // Note spese del mese approvata
    const reportsApproved = _vm.reports
        .filter(r => 
          _vm.user.idWorldUser === r.user
          && _vm.$moment.unix(r.reportDate).isSame(_vm.$moment(), 'month') 
          && r.status === 1
        )
        .length === 0;
    return !projectCompleted && !projectInvoicedOrCanceled && reportsApproved;
  },
  link_canEditOutgo(_vm, outgo) {
    // Carico gli employments così da avere il responsabile dipendente per ogni employment
    const creatorEmployments = _vm.$store.getters['employments/getByUser'](outgo.user)
        .filter(e => _vm.project.developers.includes(e.work) && e.accountable === _vm.user.idWorldUser);
    const projectWaitingOrRunning = 
        (_vm.project.status < 3 || _vm.project.status === 6)
        && _vm.userPermission > 3 //manager
        && outgo.user !== _vm.user.idWorldUser // creatore
        && !_vm.customerManager // responsabile cliente
        && creatorEmployments.length === 0 // responsabile dipendente del creatore
    ;
    const projectCompleted =  
        _vm.project.status === 3
        && _vm.userPermission > 3; //manager
    // Progetto fatturato o cancellato
    const projectInvoicedOrCanceled = _vm.project.status === 4 || _vm.project.status === 5;
    // Note spese del mese approvata
    const reportsApproved = _vm.reports
        .filter(r => 
          outgo.user === r.user
          && _vm.$moment.unix(r.reportDate).isSame(_vm.$moment.unix(outgo.outgoDate), 'month')
          && r.status === 1)
        .length === 0;
    // Spesa accoppiata automaticamente
    const matched = outgo.verificationType !== 2;
    return !projectWaitingOrRunning && !projectCompleted && !projectInvoicedOrCanceled && reportsApproved && matched;
  },
  link_canAddReceipt(_vm, outgo) {
    // Carico gli employments così da avere il responsabile dipendente per ogni employment
    const creatorEmployments = _vm.$store.getters['employments/getByUser'](outgo.user)
        .filter(e => _vm.project.developers.includes(e.work) && e.accountable === _vm.user.idWorldUser);
    const technicianNotCreator = 
        _vm.userPermission > 3 //manager
        && outgo.user !== _vm.user.idWorldUser //creatore
        && !_vm.customerManager // responsabile cliente
        && creatorEmployments.length === 0 // responsabile dipendente del creatore
    ;
    return !technicianNotCreator;
  }
}